import PropTypes from 'prop-types';

import Forms from '@components/form';

import { form_container, no_wrap } from '../styles.module.scss';

const StepOne = ({ agent, listingId, nextStepCallback, agentId, openHouse }) => {
  return (
    <div>
      <h2>Welcome! Please Sign In.</h2>
      <p>
        {openHouse && (
          <>
            Hosted by {agent?.displayPrimary} on <span className={no_wrap}>{openHouse}</span>
          </>
        )}
      </p>
      <div className={form_container}>
        <Forms
          submitLabel="Submit"
          listingId={listingId}
          nextStepCallback={nextStepCallback}
          agentIds={[agentId]}
          requestType="Open House"
          shouldShowConsentToContact
          shouldShowWorkingWithAgent
          defaultValueWorkingWithAgent={agent?.displayPrimary}
          shouldShowComments={false}
        />
      </div>
    </div>
  );
};

StepOne.propTypes = {
  agent: PropTypes.object,
  userInfo: PropTypes.object,
  listingId: PropTypes.string,
  nextStepCallback: PropTypes.func,
  loggedInUserId: PropTypes.string,
  associatedAgentId: PropTypes.string,
  agentCallback: PropTypes.func,
  agentId: PropTypes.string,
  openHouse: PropTypes.string
};

export default StepOne;
